import script from "./UnderwritingAnalysisPage.vue?vue&type=script&setup=true&lang=js"
export * from "./UnderwritingAnalysisPage.vue?vue&type=script&setup=true&lang=js"

import "./UnderwritingAnalysisPage.vue?vue&type=style&index=0&id=21ea5a44&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\ProtectionGuruVue\\client-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21ea5a44"]])

export default __exports__